import { Component, OnInit } from '@angular/core';
import { ManagementService } from 'src/app/services/management.service';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-manegement-portal',
  templateUrl: './manegement-portal.component.html',
  styleUrls: ['./manegement-portal.component.scss']
})
export class ManegementPortalComponent implements OnInit {

  key: string;
  portalForm: UntypedFormGroup;
  message: string;

  constructor(
    private management: ManagementService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly recaptcha: ReCaptchaV3Service,
    private readonly serviceAuthen: AuthenticationService,
    private route: Router) { }

  ngOnInit() {
    this.portalForm = this.formBuilder.group({
      user: new UntypedFormControl('', [Validators.required]),
      pass: new UntypedFormControl('', [Validators.required])
    }, {});
    this.getKey();
  }

  getKey() {
    if (!sessionStorage.getItem('k_ca')) {
      this.serviceAuthen.getCaptchaKey().subscribe((key: any) => {
        sessionStorage.setItem('k_ca', key.gsv || key);
        sessionStorage.setItem('country', key.Country);
        if (key.Language) {
          sessionStorage.setItem('language', key.Language);
        }
        this.key =  key.gsv || key;
      });
    } else {
      this.key = sessionStorage.getItem('k_ca');
    }
  }

  sendForm() {
    this.message = '';
    if (this.portalForm.get('user').value && this.portalForm.get('pass').value) {
      const d = {
        user: this.portalForm.get('user').value,
        pass: this.portalForm.get('pass').value
      };
      this.recaptcha.execute(this.key, 'login', (token) => {
        this.management.loginManagement(d, token).subscribe(data => {
          if (data.Code === 200) {
            sessionStorage.setItem('t_admin', data.Token);
            this.route.navigateByUrl('/admin');
          } else {
            this.message = data.Message + ' Codigo ' + data.Code;
          }
        }, errors => {
          this.message = errors;
        });
      }, { useGlobalDomain: true });

    }
  }
}
